import Vue from "vue"
import resetMixin from "~/mixins/store/resetToInitialState"

const initialState = function () {
  return {
    id: 0,
    band: 0,
    info: "",
    link: "",
    ep_link: "",
    event: "",
    secondary_link: "",
    name: "",
    release_date: "",
    is_demo: false,
    is_exclu: false,
    is_public: false,
    created_from_profile: true,
  }
}

export const state = initialState

export const mutations = {
  UPDATE: function (state, track) {
    const ignore_type = []

    for (let key in state)
      if (
        ignore_type.includes(key) ||
        (track[key] !== null && track[key] !== undefined)
      )
        Vue.set(state, key, track[key])
  },
  ...resetMixin.mutations,
}

export const actions = {
  FETCH: async function ({ commit }, track_id) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$get(`/track/track/${track_id}/`)
        .then((resp) => {
          commit("UPDATE", resp)
          resolve(resp)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  UPDATE_ON_SERVER: function ({ dispatch }, track) {
    track.release_date = track.release_date?.length ? track.release_date : null
    if (track.id) return dispatch("SERVER_PATCH", track)
    else return dispatch("SERVER_POST", track)
  },
  SERVER_POST: function ({ commit }, track) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$post("/track/track/", {
          ...track,
        })
        .then((track) => {
          commit("UPDATE", track)
          resolve(track)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  SERVER_PATCH: function ({ commit }, track) {
    return new Promise((resolve, reject) => {
      this.$axios
        .$patch(`/track/track/${track.id}/`, {
          ...track,
        })
        .then((track) => {
          commit("UPDATE", track)
          resolve(track)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  RESET: function ({ commit }) {
    const swp = initialState()
    commit("RESET", swp)
  },
}

export const getters = {
  INITIAL_STATE: function () {
    return initialState()
  },
}
